<template>

    <div>

        <div class="weforest__container">
            <div class="weforest__page">

                <h1 v-if="$mq !== 'lg'" class="cf-title-3">{{ $t('we_forest_title') }}</h1>

                <p class="weforest__subtitle">{{ $t('we_forest_description') }}</p>


                <article class="weforest__article">

                    <h2 class="weforest__share-title">{{ $t('we_forest_code') }}</h2>

                    <button class="weforest__button-code pointer" @click="copyCode">

                        <span class="weforest__code">{{ code }}</span>

                        <span v-if="!codeCopied" class="weforest__code-to-copy">{{ $t('we_forest_click_to_copy') }}</span>
                        <span v-else class="weforest__code-copied">{{ $t('we_forest_code_copied') }}</span>

                    </button>

                    <button class="btn btn-blue btn-big weforest__btn-share" @click="share">{{ $t('cleaning_cards_sharing_cta') }}</button>

                </article>


                <article class="weforest__article-trees">

                    <div class="weforest__article-green">

                        <div class="weforest__article-green-left">

                            <img class="weforest__article-green-icon" src="/img/icons/tree-white.svg">

                            <span class="weforest__article-green-text">{{ $t('we_forest_my_trees') }}</span>

                        </div>

                        <div class="weforest__article-green-right">{{ sqm }}</div>

                    </div>


                    <div :class="{ 'weforest__sponsor-min-height': !(trees.length && !toggleOpen) }" class="weforest__sponsor">

                        <lottie-loader v-if="requestingTrees" :size="32"></lottie-loader>

                        <main v-if="!requestingTrees && trees.length === 0 && !error" class="weforest__sponsor-empty">

                            <img class="weforest__sponsor-empty-logo" src="/img/foxy/mailbox-empty.svg">

                            <h2 class="weforest__sponsor-empty-title">{{ $t('we_forest_no_planted_tree') }}</h2>

                            <p class="weforest__sponsor-empty-subtitle">{{ $t('we_forest_no_planted_tree_description') }}</p>

                            <button class="btn btn-blue btn-big weforest__btn-share" @click="share">{{ $t('we_forest_invite_friends') }}</button>

                        </main>

                        <main v-if="!requestingTrees && trees.length && !error" class="weforest__sponsors">

                            <div class="weforest__sponsors-space"></div>

                            <div class="weforest__sponsors-container">

                                <div v-for="(tree, index) in computedTrees" :class="{ 'card__divider': showDivider(index) }" class="card">

                                    <div class="card__left">

                                        <div class="card__name">{{ referrerName(tree.name) }}</div>

                                        <div class="card__date">{{ $tc('we_forest_reffered_on_date', 0, {date: dateFormat(tree.date)}) }}</div>

                                    </div>

                                    <div class="card__right">

                                        <!--                                    <img src="/img/icons/medal.svg" class="card__icon">-->

                                    </div>

                                </div>

                                <div v-if="trees.length > 3" class="card__toggle" @click="toggleCards">

                                    <p class="card__toggle-text">{{ computedToggleText }}</p>

                                    <img :style="computedArrowDirection" class="card__toggle-icon" src="/img/icons/arrow-blue.svg">

                                </div>

                            </div>


                        </main>

                        <main v-if="error" class="weforest__error">

                            <img class="weforest__error-img" src="/img/my-actions/actions-error.svg">

                            <p class="weforest__error-text">{{ $t('magic_error_subtitle') }}</p>

                            <button class="weforest__error-cta" @click="getSponsorship">{{ $t('magic_error_cta') }}</button>

                        </main>

                    </div>


                </article>


                <article class="weforest__article">

                    <p class="weforest__redirect-text">{{ $t('we_forest_we_forest_description') }}</p>

                    <button class="weforest__redirect-button" @click="redirectWeForest">

                        <span class="weforest__redirect-button-text">{{ $t('we_forest_discover_weforest') }}</span>

                        <img class="weforest__redirect-button-icon" src="/img/icons/arrow-right-blue.svg">

                    </button>

                </article>

            </div>
        </div>

        <TabBar></TabBar>

        <modal-share ref="MS"></modal-share>

    </div>

</template>

<script>

import Vuex from 'vuex'

import Api from '@/api'

import I18n from '@/modules/i18n'
import LottieLoader from '@/components/lottie/LottieLoader'
import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

import TabBar from '@/components/TabBar'
import ModalShare from '../components/modal/ModalShare'

export default {

    name: 'we-forest',

    components: {ModalShare, LottieLoader, TabBar},

    watch: {},

    computed: {

        ...Vuex.mapGetters(['user']),

        computedArrowDirection: function () {

            return {
                transform: this.toggleOpen ? 'rotate(90deg)' : 'rotate(270deg)'
            }

        },

        computedTrees: function () {

            return this.toggleOpen ? this.trees : this.trees.slice(0, 3)
        },

        computedToggleText: function () {

            return this.toggleOpen ? this.$t('we_forest_show_less') : this.$t('we_forest_show_more')

        }
    },

    data() {
        return {
            trees: [],
            requestingTrees: false,
            toggleOpen: false,
            codeCopied: false,
            code: '',
            error: false,
            sqm: 0
        }
    },

    created() {

        if (!this.user.partnerCode) {
            this.$router.push({path: '/stats'})
        }

        UserFlow.setPage(this, 'we_forest')
    },

    mounted() {

        this.getSponsorship()

        if (this.user.partnerCode) {

            this.code = this.user.partnerCode

        }

    },

    methods: {

        getSponsorship() {

            this.error = false

            this.requestingTrees = true

            Api.sponsorship.get()
                .then(response => {

                    this.trees = response.referrals
                    this.sqm = Math.round(response.sqm)

                    if (response.code) {

                        this.code = response.code

                    }


                })
                .catch(() => {

                    this.error = true
                })
                .finally(() => {
                    this.requestingTrees = false
                })
        },

        redirectWeForest() {

            window.open('https://www.weforest.org/partner/cleanfox')

        },

        toggleCards() {

            this.toggleOpen = !this.toggleOpen

        },

        copyCode() {

            const el = document.createElement('textarea')
            el.value = this.code
            document.body.appendChild(el)
            el.select()
            document.execCommand('copy')
            document.body.removeChild(el)

            this.codeCopied = true

        },

        share() {

            Tag.clickAmplitude(this, 'sharing')
            this.$refs.MS.open(true)

        },

        dateFormat(dateStr) {

            const date = new Date(dateStr)

            return date.toLocaleDateString(I18n.get(this))
        },

        showDivider: function (index) {

            return !(index === this.trees.length - 1 && this.trees.length < 4)

        },

        referrerName(name) {

            return name ? name : this.$t('we_forest_deleted_user')
        }
    }
}
</script>


<style lang="scss" scoped>

.weforest {


    &__container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
        background-color: $timberwolf;
        padding: 24px 16px 88px;
        @media screen and (min-width: $above-tablet-length) {
            padding: 47px 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: url(/img/background/cards-desktop.svg);
            background-repeat: no-repeat;
            background-position: bottom;
            background-size: cover;
            background-blend-mode: luminosity;
            flex-direction: column;
        }
    }

    &__page {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 480px;
    }

    &__subtitle {
        text-align: left;
        margin-top: 24px;
        font-size: 17px;
        line-height: 1.29;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 0;
        }
    }

    &__article {
        display: flex;
        flex-direction: column;
        margin-top: 24px;
        width: 100%;
        background-color: $white;
        padding: 24px;
        border-radius: 8px;
        align-items: center;
    }

    &__share-title {
        margin: 0;
        font-size: 17px;
        font-weight: 600;
        line-height: 1.29;
    }

    &__button-code {
        margin: 16px 0;
        padding: 7PX;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: $white;
        border-radius: 32px;
        border: dashed 2px $silver;
        color: $aquamarine;
        max-width: 256px;
        width: 100%;

        &:hover {
            color: $blue-hover
        }

        &:active {
            color: $blue-active;
        }
    }

    &__code {
        font-size: 28px;
        font-weight: bold;
        color: $stone;
    }

    &__code-to-copy {
        font-size: 13px;
        font-weight: 600;
        line-height: 1.38;
    }

    &__code-copied {
        font-size: 13px;
        font-weight: 600;
        line-height: 1.38;
        color: $lime;
    }

    &__btn-share {
        max-width: 187px;
    }

    &__article-trees {
        margin-top: 24px;
        width: 100%;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
    }

    &__article-green {
        width: 100%;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        background-color: $forest;
        padding: 12px 12px 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        color: $white;
    }

    &__article-green-left {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    &__article-green-icon {
        width: 24px;
        object-fit: contain;
    }

    &__article-green-text {
        margin-top: 12px;
        font-size: 15px;
        font-weight: 600;
        line-height: 1.33;
    }

    &__article-green-right {
        font-size: 34px;
        font-weight: bold;
        line-height: 1.21;
    }

    &__sponsor {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $white;
    }

    &__sponsor-min-height {
        min-height: 279px;
    }

    &__sponsor-empty {
        padding: 32px 24px 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    &__sponsor-empty-logo {
        width: 80px;
        object-fit: contain;
    }

    &__sponsor-empty-title {
        margin-top: 16px;
        font-size: 17px;
        font-weight: bold;
        line-height: 1.29;
        letter-spacing: -0.41px;
    }

    &__sponsor-empty-subtitle {
        margin: 4px 0 16px;
        font-size: 12px;
        line-height: 1.33;
        color: $moon;
    }

    &__sponsors {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    &__sponsors-space {
        width: 16px;
    }

    &__sponsors-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    &__error {
        width: 100%;
        padding: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;


    }

    &__error-text {
        object-fit: contain;
        width: 100%;
    }

    &__error-text {
        margin-top: 16px;
        font-size: 12px;
        line-height: 1.33;
        color: $moon;
    }

    &__error-cta {
        margin-top: 8px;
        font-size: 12px;
        font-weight: bold;
        line-height: 1.33;
        color: $aquamarine;
        background-color: $white;
    }

    &__redirect-text {
        font-size: 17px;
        line-height: 1.29;
        text-align: left;
    }

    &__redirect-button {
        margin-top: 16px;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        background-color: $white;
    }

    &__redirect-button-text {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.31;
        color: $aquamarine;
    }

    &__redirect-button-icon {
        width: 24px;
        object-fit: contain;
        margin-left: 6px;
    }
}

.card {
    width: 100%;
    padding: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    text-align: left;

    &__divider {
        border-bottom: 1px solid $silver;
    }

    &__left {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    &__name {
        font-size: 16px;
        font-weight: 600;
        line-height: 1.31;
    }

    &__date {
        margin-top: 2px;
        font-size: 11px;
        font-weight: 600;
        line-height: 1.18;
        color: $stone;
    }

    &__right {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__icon {
        width: 32px;
        object-fit: contain;
    }

    &__toggle {
        height: 56px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    &__toggle-text {
        font-size: 16px;
        font-weight: bold;
        color: $aquamarine;
    }

    &__toggle-icon {
        width: 24px;
        object-fit: contain;
    }
}

</style>
